<!-- Header Start -->
<div class="container-fluid bg-dark px-0">
    <div class="row gx-0">
        <div class="col-lg-4 bg-dark d-none d-lg-block">
            <a [routerLink]="['/']"
                class="navbar-brand w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center">
                <img [src]="logoSrc" [alt]="'HEADER.LOGO_ALT' | translate" style="height: 60px;"
                    class="me-3">
                <h1 class="m-0 display-5 text-primary">{{ brandName }}</h1>
            </a>
        </div>
        <div class="col-lg-8">
            <div class="row gx-0 bg-secondary d-none d-lg-flex">
                <div class="col-lg-7 px-5 text-start">
                    <div class="h-100 d-inline-flex align-items-center py-2 me-4">
                        <i class="fa fa-envelope text-primary me-2"></i>
                        <h6 class="mb-0">
                            <a [href]="'mailto:' + contactEmail">{{ contactEmail }}</a>
                        </h6>
                    </div>
                    <div class="h-100 d-inline-flex align-items-center py-2">
                        <i class="fa fa-phone-alt text-primary me-2"></i>
                        <h6 class="mb-0">{{ contactPhone }}</h6>
                    </div>
                </div>
                <div class="col-lg-5 px-5 text-end">
                    <div class="d-inline-flex align-items-center py-2">
                        <a class="btn btn-light btn-square rounded-circle me-2"
                            href="https://web.facebook.com/profile.php?id=100063689845829"><i
                                class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-light btn-square rounded-circle me-2" href="https://twitter.com/Wescotcorp"><i
                                class="fab fa-twitter"></i></a>
                        <a class="btn btn-light btn-square rounded-circle me-2"
                            href="https://www.linkedin.com/in/wescot-corporation-2081b0263/"><i
                                class="fab fa-linkedin-in"></i></a>
                        <a class="btn btn-light btn-square rounded-circle me-2"
                            href="https://www.instagram.com/wescotcorporation/"><i class="fab fa-instagram"></i></a>
                        <a class="btn btn-light btn-square rounded-circle"
                            href="https://www.youtube.com/channel/UCCBmxSEmCeFUKNgY5bes6bQ"><i
                                class="fab fa-youtube"></i></a>
                    </div>
                </div>
            </div>
            <nav class="navbar navbar-expand-sm bg-dark navbar-dark p-1 p-lg-0 px-lg-5">
                <a [routerLink]="['/']" class="navbar-brand d-block d-lg-none">
                    <img [src]="logoSrc" [alt]="'HEADER.LOGO_ALT' | translate" style="height: 40px;"
                        class="me-2">
                    <h1 class="m-0 text-primary">{{ brandName }}</h1>
                </a>
                <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-between" id="navbarCollapse">
                    <div class="navbar-nav mr-auto py-0">
                        <a *ngFor="let link of navLinks" [routerLink]="link.path" class="nav-item nav-link"
                            routerLinkActive="active" [routerLinkActiveOptions]="{exact: link.path === '/'}"
                            style="cursor: pointer;">
                            {{ link.label | translate }}
                        </a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- Header End -->